import { Box, CircularProgress, Stack, styled, Typography } from '@mui/material';
import { HeaderClient } from '../FloorPlan/components/elements/HeaderClient';
import { FloorPlanIssueViewer } from './components/modules/FloorPlanIssueViewer';
import { useInjection } from './hook';

export const FloorPlanViewPage = () => {
  const { paths, handleBack, floorPlanUrl, floorPlanId, isLoading } = useInjection();

  return (
    <WrapperFloorPlanPage>
      <HeaderClient
        searchholder="Search"
        title={paths.at(-1)?.name}
        textButton="Back"
        onClickButton={handleBack}
        paths={paths}
      />

      <ViewerCard>
        {isLoading ? (
          <EmptyState>
            <CircularProgress
              size={36}
              sx={{
                color: '#226AAA'
              }}
            />

            <Typography color="#6B7280">Loading floor plan...</Typography>
          </EmptyState>
        ) : floorPlanUrl ? (
          <FloorPlanIssueViewer floorPlanUrl={floorPlanUrl} floorPlanId={floorPlanId} />
        ) : (
          <EmptyState>
            <Stack alignItems="center" gap="4px">
              <Typography
                sx={{
                  color: '#334155',
                  fontSize: '16px',
                  fontWeight: 600
                }}>
                Floor plan not available
              </Typography>

              <Typography
                sx={{
                  color: '#6B7280',
                  fontSize: '14px'
                }}>
                No floor plan has been uploaded for this location.
              </Typography>
            </Stack>
          </EmptyState>
        )}
      </ViewerCard>
    </WrapperFloorPlanPage>
  );
};

const WrapperFloorPlanPage = styled(Stack)(() => ({
  width: '100%',
  height: '100vh',
  padding: '40px 30px 30px 40px',
  gap: '10px',
  overflow: 'hidden'
}));

const ViewerCard = styled(Stack)(() => ({
  width: '100%',
  minHeight: 0,
  flex: 1,
  overflow: 'hidden',
  backgroundColor: '#FFFFFF'
}));

const EmptyState = styled(Stack)(() => ({
  width: '100%',
  height: '100%',
  minHeight: '350px',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px'
}));
